import {
  PictureListItemData,
  PictureListTypeData,
  classNames,
  formatMultilineText,
} from "@plinknz/tah-website-elements";
import * as React from "react";
import { useVisible } from "react-visible-image";
import { generate } from "shortid";

export interface PictureListProps {
  data: PictureListTypeData;
}

interface PictureListItemRenderData extends PictureListItemData {
  imageSide: string;
}

const PictureListItem = ({
  title,
  picture,
  subtitle,
  description,
  background_colour,
  imageSide,
}: PictureListItemRenderData) => {
  const item = React.useRef<HTMLDivElement>(null);
  const isVisible = useVisible(item);
  const profileClass = classNames("profile");
  const background = background_colour ? { background: background_colour } : {};
  const textSide = imageSide === "right" ? "left" : "right";

  return (
    <div className={profileClass} ref={item} key={generate()}>
      <h2 className={`profile-content-title ${textSide}`}>{title}</h2>
      <div className="profile-columns">
        <div
          className={`profile-image bottom ${imageSide}`}
          style={{
            backgroundImage: isVisible ? `url('${picture?.url}')` : "",
          }}
        />
        <div className={`profile-columns-text ${textSide}`} style={background}>
          {subtitle && <h2 className="profile-subtitle">{subtitle}</h2>}
          {description && (
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: formatMultilineText(description),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const PictureList = ({ data }: PictureListProps) => {
  if (!data?.profiles) {
    return <></>;
  }

  let right = true;
  const profiles = data.profiles.map((profile) => {
    const imageSide = right ? "right" : "left";
    right = !right;

    return { ...profile, imageSide };
  });

  return (
    <div className="profile-wrapper || constrain-width" data-testid="profile">
      <h3>{data.profileHeading}</h3>
      <div>{profiles.map(PictureListItem)}</div>
    </div>
  );
};
